import { render, staticRenderFns } from "./agv-customer-orders-table.vue?vue&type=template&id=2baf9673&scoped=true&lang=pug&"
import script from "./agv-customer-orders-table.vue?vue&type=script&lang=js&"
export * from "./agv-customer-orders-table.vue?vue&type=script&lang=js&"
import style0 from "./agv-customer-orders-table.vue?vue&type=style&index=0&id=2baf9673&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2baf9673",
  null
  
)

export default component.exports